import http from "../common/http-common";
import authHeader from '../common/auth-header';




class SessionFormationService {

    getAll(params) {
       // console.log('In SessionFormationService getAll : ')
       // console.log(params);
        var headers = authHeader();
        let config = {
            headers,
            params: params,
        }
       // console.log(config)

        return http.get("/sessions", config);
    }

    getAllOld() {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get("/sessions", config);
    }





    get(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.get(`/sessions/${id}`, config);
    }

    getPaimentsMode(id){
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log('getPaimentsMode - config =');
        //console.log(config)
        return http.get(`/sessions/paymodes/${id}`, config);
    }

    create(event) {
        var headers = authHeader();
        //console.log('event.target.startDate.value : '+event.target.startDate.value);
        const id = event.target.formationId.value;
        var raw = JSON.stringify({
              "startDate": event.target.startDate.value,
              "endDate": event.target.endDate.value,
              "location": event.target.location.value,
              "name": event.target.name.value,
            });
            
        //var raw = JSON.stringify(item);

        console.log(raw);
        let config = {
            headers,
        }
        return http.post(`/sessions/${id}`, raw, config);
    }


    update(id, event) {
        var headers = authHeader();
        // console.log('event.target.name.value : '+event.target.name.value);
        //console.log(event);
        var raw = JSON.stringify({
            "startDate": event.target.startDate.value,
            "endDate": event.target.endDate.value,
            "location": event.target.location.value,
            "name": event.target.name.value,
            "formation": {
                "id": event.target.formationId.value,
            }
        });
       // console.log(raw);
        let config = {
            headers,
        }
        return http.put(`/sessions/${id}`, raw, config);
    }


    delete(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.delete(`/sessions/${id}`, config);
    }

    deleteAll() {
        return http.delete("/sessions");
    }



}

export default new SessionFormationService();
